<div
  (click)="handleOpen()"
  class="add-configuration-container global-transition"
  [ngClass]="{
    'error-select error-container': configForm.select.invalid && submitted,
    'select-menu-container': isSelectMenuOpen
  }">
  <ng-container *ngIf="fieldInfo?.translations; else trackingDomain">
    <ng-container *ngFor="let name of fieldInfo?.translations">
      <h5 class="name-label" for="configuration-name" *ngIf="name.lang === panelLanguage">{{ name.label }}</h5>
    </ng-container>
  </ng-container>
  <ng-template #trackingDomain>
    <h5 for="configuration-name">{{ 'view_translations.tracking_domain' | translate }}</h5>
  </ng-template>
  <div #selectFormContainer class="inputSelectForm">
    <form [formGroup]="selectForm">
      <ng-select
        [ngClass]="{'error-select': configForm.select.invalid && submitted }"
        notFoundText="{{ 'view_translations.no_data' | translate }}"
        [searchable]="false"
        placeholder="{{ 'view_translations.select_label' | translate }}"
        class="select-menu smaller-container"
        [items]="$any(fieldInfo?.translations ? values : fieldInfo?.values)"
        bindLabel="value"
        bindValue="id"
        (open)="changeChevron('open')"
        (close)="changeChevron('close')"
        formControlName="select"
        (change)="getValue($event)"
        [isOpen]="isSelectMenuOpen"
        [clearable]="false"
        appendTo="body"
        dropdownPosition="bottom">
      </ng-select>
    </form>
  </div>
  <nb-icon class="error-icon" icon="cross-circle" pack="icomoon" *ngIf="configForm.select.invalid && submitted"></nb-icon>
</div>
<div class="error-text form-error-text" *ngIf="configForm.select.invalid && submitted">
  <div class="form-text text-danger">{{ 'view_translations.this_field_is_required' | translate }}</div>
</div>
